/*  Shared  */
import { CellContext } from '@tanstack/react-table';
import { RiskPicker } from 'application/Shared/Components/Pickers';
import { RISK_FILTER_ORDER } from 'application/Shared/Constants';
import { TenantApp } from 'application/Shared/types/tenantApp';

/*  React  */
import React from 'react';

import { ColumnFilter } from '../Table/types';

export const riskCellFilter: ColumnFilter<TenantApp> = {
    defaultOptions: [
        {
            options: RISK_FILTER_ORDER
        }
    ]
};

export const RiskCell = <TData,>(props: CellContext<TData, unknown>) => {
    const { cell, ...rest } = props;
    return <RiskPicker visualOnly value={cell.getValue()} {...rest} />;
};
